module.exports = __webpack_public_path__ + "img/@tmp_group_symbol_02.f6ca8196.jpg";